/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2021-12-13 16:35:36
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 16:49:48
 */
import { Form, Input, Select, Button, Row, Col, Space, DatePicker } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import {
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from "../../models/datetime"
import moment from "moment"
import { DateSelect, TJFXTime } from "../../compnents/form/DateSelect"
import { useHistory } from "react-router-dom"
const { Option } = Select

export const Query = (props: {
  loading?: any
  timeHead?: string
  timeTail?: string
  onValueChange: (queries: any) => void
}) => {
  const history = useHistory()

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const { RangePicker } = DatePicker

  const [timeFlag, setTimeFlag] = useState<any>("1")

  return (
    <Form
      form={form}
      onFinish={(vs) => {
        console.log(vs);
        
        const startTime = vs?.timeHead ?
          moment(vs?.timeHead)?.format(DateTimeFormatSimpleOnly) +
          " " +
          "00:00:00" : ''
        const endTime = vs?.timeTail ?
          moment(vs?.timeTail)?.format(DateTimeFormatSimpleOnlyOne) +
          " " +
          "23:59:59" : ''
        props.onValueChange(
          {
            ...vs,
            timeHead: startTime,
            timeTail: endTime
          },
        )
      }}
    >
      <Row
        style={{ marginBottom: 10, width: "100%" }}
        align="middle"
        justify="space-between"
      >
        <Space>
          <Form.Item name="selfType" noStyle>
            <Select
              allowClear
              placeholder="自查类型"
              style={{ width: "10rem" }}
              onChange={(v) => {
                form.submit()
              }}
            >
              <Select.Option value={0}>季度自查</Select.Option>
              <Select.Option value={1}>年度自查</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="reviewStatus" noStyle>
            <Select
              placeholder="状态"
              style={{ width: "10rem" }}
              allowClear
              onChange={(v) => {
                form.submit()
              }}
            >
              <Select.Option value={0}>待审核</Select.Option>
              <Select.Option value={1}>已通过</Select.Option>
              <Select.Option value={2}>已退回</Select.Option>
            </Select>
          </Form.Item>
          <DateSelect
            allowClear
            style={{ width: "10rem" }}
            labelPrefix=""
            namePrefix="time"
            options={TJFXTime}
            placeholder="审核日期"
            onChange={() => form.submit()}
          />
          <Button htmlType="submit" type="primary" loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space style={{ float: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              history.push({
                pathname: "/selfInspectionLegalPractice/add",
                state: { 
                  type: 1
                 },
              })
            }}
          >
            新增自查
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
